import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const hotlines = (companyInfo.hotlines?.length
    ? companyInfo.hotlines
    : [companyInfo.hotline, companyInfo.secondaryHotline]
  ).filter(Boolean);
  const formatTelHref = (value = '') => `tel:${value.replace(/\s+/g, '')}`;

  const quickLinks = [
    { path: '/', label: 'Trang chủ' },
    { path: '/about', label: 'Thương hiệu' },
    { path: '/products', label: 'Sản phẩm' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12 max-w-screen-4xl 3xl:px-12 4xl:px-16 3xl:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 3xl:gap-12 4xl:gap-16">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4 3xl:gap-4">
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.brandName} 
                className="h-12 w-12 object-contain bg-white rounded-lg p-1 3xl:h-16 3xl:w-16"
              />
              <div>
                <h3 className="font-bold text-lg text-cyan-400 3xl:text-xl">{companyInfo.brandName}</h3>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-cyan-400 3xl:text-xl">Liên kết nhanh</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-slate-300 hover:text-cyan-400 transition-colors text-sm 3xl:text-base"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-cyan-400 3xl:text-xl">Thông tin liên hệ</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5 3xl:h-6 3xl:w-6" />
                <div>
                  <p className="text-sm text-slate-400 3xl:text-base">Hotline/Zalo</p>
                  <div className="flex flex-col gap-1">
                    {hotlines.map((phone) => (
                      <a
                        key={phone}
                        href={formatTelHref(phone)}
                        className="text-slate-200 hover:text-cyan-400 transition-colors font-medium"
                      >
                        {phone}
                      </a>
                    ))}
                  </div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5 3xl:h-6 3xl:w-6" />
                <div>
                  <p className="text-sm text-slate-400 3xl:text-base">Email</p>
                  <a 
                    href={`mailto:${companyInfo.email}`}
                    className="text-slate-200 hover:text-cyan-400 transition-colors"
                  >
                    {companyInfo.email}
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Address & Hours */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-cyan-400 3xl:text-xl">Địa chỉ</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5 3xl:h-6 3xl:w-6" />
                <p className="text-slate-300 text-sm 3xl:text-base">
                  {companyInfo.address}
                </p>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5 3xl:h-6 3xl:w-6" />
                <div>
                  <p className="text-sm text-slate-400 3xl:text-base">Giờ làm việc</p>
                  <p className="text-slate-300 text-sm 3xl:text-base">{companyInfo.workingHours}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 text-center 3xl:pt-10">
          <p className="text-slate-400 text-sm 3xl:text-base">
            © {currentYear} {companyInfo.name}. Tất cả quyền được bảo lưu.
          </p>
        </div>
      </div>
    </footer>
  );
};
